import { api } from "@/lib/api";

const VISITOR_KEY = "pronet_visitor_id";

export function getVisitorId() {
  try {
    let visitorId = window.localStorage.getItem(VISITOR_KEY);
    if (!visitorId) {
      visitorId = window.crypto?.randomUUID?.()
        || `pn-${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
      window.localStorage.setItem(VISITOR_KEY, visitorId);
    }
    return visitorId;
  } catch {
    return `pn-session-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

export async function trackWebsiteVisit() {
  const { data } = await api.post("/public/visit", { visitor_id: getVisitorId() });
  window.dispatchEvent(new CustomEvent("pronet:visitor-count", { detail: data }));
  return data;
}

export async function trackProfileView(memberId) {
  if (!memberId) return null;
  const { data } = await api.post(
    `/public/members/${encodeURIComponent(memberId)}/view`,
    { visitor_id: getVisitorId() },
  );
  return data;
}
